import { render, staticRenderFns } from "./AttributeDefinitionTemplatesView.vue?vue&type=template&id=1c65ea25&lang=pug&"
import script from "./AttributeDefinitionTemplatesView.vue?vue&type=script&lang=ts&"
export * from "./AttributeDefinitionTemplatesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports